import { toTitleCase } from './text'

export {
  toTitleCase,
}
